/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { jingleModelPagedResultSchema } from "../jingleModelPagedResultSchema.ts";
import { trackUploadStatusSchema } from "../trackUploadStatusSchema.ts";
import { z } from "zod";

export const getApiJingleCollectionsIdJinglesPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки джинглов")
    })

export const getApiJingleCollectionsIdJinglesQueryParamsSchema = z.object({
    "UploadStatuses": z.array(z.lazy(() => trackUploadStatusSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n")).describe("Фильтр по статусу загрузки").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список джинглов
 */
export const getApiJingleCollectionsIdJingles200Schema = z.lazy(() => jingleModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiJingleCollectionsIdJingles400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiJingleCollectionsIdJingles401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiJingleCollectionsIdJingles403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const getApiJingleCollectionsIdJingles404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiJingleCollectionsIdJingles500Schema = z.lazy(() => badResponseModelSchema)

export const getApiJingleCollectionsIdJinglesQueryResponseSchema = z.lazy(() => getApiJingleCollectionsIdJingles200Schema)